import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("stats-callout-v2", {
  initSlider() {
    const carousel = this.container.querySelector(".stats-callout-v2__items");
    if (!carousel) return;
    const swiper = new Swiper(carousel, {
      loop: true,
      slidesPerView: 2,
      navigation: {
        nextEl: carousel.querySelector(".swiper-button-next"),
        prevEl: carousel.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        767: {
          slidesPerView: 4,
          allowTouchMove: false,
          loop: false,
        },
      },
    });
  },

  onLoad: function (e) {
    this.initSlider();
  },
});
